export default __webpack_public_path__ + "static/media/spectrophotometer-info-2.9b3dab0e.svg";